import request from '@/utils/request'


// 查询调机米数列表
export function listMachine(query) {
  return request({
    url: '/user/machine/list',
    method: 'get',
    params: query
  })
}

// 查询调机米数分页
export function pageMachine(query) {
  return request({
    url: '/user/machine/page',
    method: 'get',
    params: query
  })
}

// 查询调机米数详细
export function getMachine(data) {
  return request({
    url: '/user/machine/detail',
    method: 'get',
    params: data
  })
}

// 新增调机米数
export function addMachine(data) {
  return request({
    url: '/user/machine/add',
    method: 'post',
    data: data
  })
}

// 修改调机米数
export function updateMachine(data) {
  return request({
    url: '/user/machine/edit',
    method: 'post',
    data: data
  })
}

// 删除调机米数
export function delMachine(data) {
  return request({
    url: '/user/machine/delete',
    method: 'post',
    data: data
  })
}

// 更新调机米数排序（仅更新 sort）
export function updateMachineSort(data) {
  return request({
    url: '/user/machine/update-sort',
    method: 'post',
    data: data
  })
}

// 更新调机米数状态（仅更新 status）
export function updateMachineStatus(data) {
  return request({
    url: '/user/machine/update-status',
    method: 'post',
    data: data
  })
}
